import { useNavigate } from 'react-router-dom'
import LocationImportTemplate from '../../../components/5templates/LocationImportTemplate'
import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'

const ImportLocationForm = () => {
    const navigate = useNavigate()
    const goToPreviousPage = () => {
        navigate('/addClient/servicesImport')
    }
    const goToNextPage = () => {
        navigate('/addClient/people')
    }

    return(
        <DataImportFormTabs flow={'addClient'}>
            <LocationImportTemplate goToPreviousPage={goToPreviousPage}
                                    goToNextPage={goToNextPage}
            />
        </DataImportFormTabs>
    )
}

export default ImportLocationForm
